import React from 'react';

const BackToStartButton = () => {
  return (
    <a
      id="cart-btn-back"
      className="btn btn-outline-info btn-lg btn-block continue-shopping text-wrap"
      data-test-id="back-to-start-button"
      href="/">
      Continue Shopping
    </a>
  );
};

export default BackToStartButton;
